import { INACTIVITY_TIMEOUT } from '../constants/constants';

/**
 * True when the app is running as an installed PWA (e.g. iPad Home Screen).
 */
export function isStandalonePwa() {
  if (typeof window === 'undefined') {
    return false;
  }
  const iosStandalone = window.navigator.standalone === true;
  const displayStandalone = window.matchMedia?.('(display-mode: standalone)')?.matches === true;
  return iosStandalone || displayStandalone;
}

export function isGuestKioskUser(user) {
  return user?.isGuest === true || user?.claims?.guest === true;
}

/** Auto-logout after inactivity applies to all signed-in users, including iPad PWA and guests. */
export function shouldEnforceInactivityLogout(user) {
  return Boolean(user);
}

export function getInactivityTimeoutMs() {
  return INACTIVITY_TIMEOUT;
}
